// Routes were renamed from French to English, then the library and the shop merged into the store (ADR 0017).
// Links shared before (friend invites, events, bookmarks, an OAuth return issued by an older API during a deploy)
// still open the right screen.
const SEGMENTS: [RegExp, string][] = [
  [/^\/evenements\/calendrier$/, '/events/calendar'],
  [/^\/evenements\/mes$/, '/events/mine'],
  [/^\/evenements\/creer$/, '/events/create'],
  [/^\/evenements(?=\/|$)/, '/events'],
  [/^\/evenement\/([^/]+)\/modifier$/, '/event/$1/edit'],
  [/^\/evenement(?=\/|$)/, '/event'],
  [/^\/en-ligne(?=\/|$)/, '/online'],
  [/^\/entrainement\/seances$/, '/training/workouts'],
  [/^\/entrainement\/creer$/, '/training/create'],
  [/^\/entrainement(?=\/|$)/, '/training'],
  [/^\/activites$/, '/activities'],
  [/^\/activite(?=\/|$)/, '/activity'],
  [/^\/progression$/, '/progress'],
  [/^\/classements\/amis$/, '/leaderboards/friends'],
  [/^\/classements(?=\/|$)/, '/leaderboards'],
  [/^\/amis\/ajouter(?=\/|$)/, '/friends/add'],
  [/^\/amis$/, '/friends'],
  [/^\/atelier\/creer(?=\/|$)/, '/workshop/create'],
  [/^\/atelier(?=\/|$)/, '/workshop'],
  [/^\/bibliotheque(?=\/|$)/, '/store'],
  [/^\/boutique$/, '/store/cosmetic'],
  [/^\/library(?=\/|$)/, '/store'],
  [/^\/shop$/, '/store/cosmetic'],
  [/^\/vestiaire$/, '/wardrobe'],
  [/^\/reglages$/, '/settings'],
  [/^\/jouer$/, '/play'],
  [/^\/connexion\/([^/]+)\/erreur\//, '/signin/$1/error/'],
  [/^\/connexion(?=\/|$)/, '/signin'],
];

/** English path for a pre-rename French path, or null when the path is not a legacy one. */
export function legacyRoute(path: string): string | null {
  for (const [re, to] of SEGMENTS) if (re.test(path)) return path.replace(re, to);
  return null;
}
